module.exports = __webpack_public_path__ + "img/CDISCOUNT_120X35.1d08417a.png";